export default __webpack_public_path__ + "static/media/immoLogo.b7e0b5cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/immoLogo.png
// module id = 192
// module chunks = 0